var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNote = function SvgNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#787473",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M5.333 1.333v2M10.667 1.333v2M4.667 8.667H10M4.667 11.333H8M10.667 2.333c2.22.12 3.333.967 3.333 4.1v4.12c0 2.747-.667 4.12-4 4.12H6c-3.333 0-4-1.373-4-4.12v-4.12C2 3.3 3.113 2.46 5.333 2.333z"
  })));
};
export default SvgNote;